var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useCallback, useEffect, useMemo } from 'react';
import NavBar from './NavBar';
import CartModal from './CartModal';
import { CartProvider } from '../context/CartContext';
import { withVersion } from '../utils/mediaVersion';
import './LabelsPage.css';
/* ═══════════════════════════════════════════════════
   Utilities
   ═══════════════════════════════════════════════════ */
function adjustBrightness(hex, f) {
    var c = function (i) { return Math.min(255, Math.max(0, Math.round(parseInt(hex.slice(i, i + 2), 16) * f))); };
    return '#' + [1, 3, 5].map(function (i) { return c(i).toString(16).padStart(2, '0'); }).join('');
}
function posterize(d, levels) {
    var f = 255 / (levels - 1);
    for (var i = 0; i < d.length; i += 4) {
        d[i] = Math.round(Math.round(d[i] / f) * f);
        d[i + 1] = Math.round(Math.round(d[i + 1] / f) * f);
        d[i + 2] = Math.round(Math.round(d[i + 2] / f) * f);
    }
}
function sobelEdges(s, w, h, t) {
    if (t === void 0) { t = 30; }
    var g = new Float32Array(w * h);
    for (var i = 0; i < w * h; i++)
        g[i] = s[i * 4] * .299 + s[i * 4 + 1] * .587 + s[i * 4 + 2] * .114;
    var o = new Uint8ClampedArray(w * h * 4);
    for (var i = 0; i < o.length; i += 4) {
        o[i] = o[i + 1] = o[i + 2] = 255;
        o[i + 3] = 255;
    }
    for (var y = 1; y < h - 1; y++)
        for (var x = 1; x < w - 1; x++) {
            var tl = g[(y - 1) * w + x - 1], tc = g[(y - 1) * w + x], tr = g[(y - 1) * w + x + 1], ml = g[y * w + x - 1], mr = g[y * w + x + 1], bl = g[(y + 1) * w + x - 1], bc = g[(y + 1) * w + x], br = g[(y + 1) * w + x + 1];
            var gx = -tl + tr - 2 * ml + 2 * mr - bl + br, gy = -tl - 2 * tc - tr + bl + 2 * bc + br;
            if (Math.sqrt(gx * gx + gy * gy) > t) {
                var i = (y * w + x) * 4;
                o[i] = o[i + 1] = o[i + 2] = 0;
            }
        }
    return o;
}
function boxBlur(d, w, h, r) {
    var c = new Uint8ClampedArray(d);
    for (var y = 0; y < h; y++)
        for (var x = 0; x < w; x++) {
            var sr = 0, sg = 0, sb = 0, n = 0;
            for (var k = -r; k <= r; k++) {
                var nx = x + k;
                if (nx >= 0 && nx < w) {
                    var i_1 = (y * w + nx) * 4;
                    sr += c[i_1];
                    sg += c[i_1 + 1];
                    sb += c[i_1 + 2];
                    n++;
                }
            }
            var i = (y * w + x) * 4;
            d[i] = sr / n;
            d[i + 1] = sg / n;
            d[i + 2] = sb / n;
        }
    var m = new Uint8ClampedArray(d);
    for (var y = 0; y < h; y++)
        for (var x = 0; x < w; x++) {
            var sr = 0, sg = 0, sb = 0, n = 0;
            for (var k = -r; k <= r; k++) {
                var ny = y + k;
                if (ny >= 0 && ny < h) {
                    var i_2 = (ny * w + x) * 4;
                    sr += m[i_2];
                    sg += m[i_2 + 1];
                    sb += m[i_2 + 2];
                    n++;
                }
            }
            var i = (y * w + x) * 4;
            d[i] = sr / n;
            d[i + 1] = sg / n;
            d[i + 2] = sb / n;
        }
}
var CSTYLES = [
    {
        id: 'cartoon', label: 'Карикатура',
        apply: function (c, w, h) {
            var d = c.getImageData(0, 0, w, h);
            var o = new Uint8ClampedArray(d.data);
            // Boost saturation for vivid cartoon colors
            for (var i = 0; i < d.data.length; i += 4) {
                var avg = (d.data[i] + d.data[i + 1] + d.data[i + 2]) / 3;
                d.data[i] = Math.min(255, Math.max(0, Math.round(avg + (d.data[i] - avg) * 1.9)));
                d.data[i + 1] = Math.min(255, Math.max(0, Math.round(avg + (d.data[i + 1] - avg) * 1.9)));
                d.data[i + 2] = Math.min(255, Math.max(0, Math.round(avg + (d.data[i + 2] - avg) * 1.9)));
            }
            // Fewer posterize levels = more graphic/comic feel
            posterize(d.data, 5);
            boxBlur(d.data, w, h, 1);
            // Thick dark edges
            var e = sobelEdges(o, w, h, 18);
            for (var i = 0; i < d.data.length; i += 4) {
                if (e[i] === 0) {
                    d.data[i] = Math.max(0, d.data[i] - 110);
                    d.data[i + 1] = Math.max(0, d.data[i + 1] - 110);
                    d.data[i + 2] = Math.max(0, d.data[i + 2] - 110);
                }
            }
            c.putImageData(d, 0, 0);
        },
    },
    {
        id: 'oil', label: 'Маслена живопис',
        apply: function (c, w, h) {
            var d = c.getImageData(0, 0, w, h);
            boxBlur(d.data, w, h, 3);
            posterize(d.data, 12);
            boxBlur(d.data, w, h, 2);
            for (var i = 0; i < d.data.length; i += 4) {
                var a = (d.data[i] + d.data[i + 1] + d.data[i + 2]) / 3;
                for (var j = 0; j < 3; j++)
                    d.data[i + j] = Math.min(255, a + (d.data[i + j] - a) * 1.4);
            }
            c.putImageData(d, 0, 0);
        },
    },
    {
        id: 'sketch', label: 'Скица',
        apply: function (c, w, h) {
            var d = c.getImageData(0, 0, w, h);
            for (var i = 0; i < d.data.length; i += 4) {
                var v = d.data[i] * .299 + d.data[i + 1] * .587 + d.data[i + 2] * .114;
                d.data[i] = d.data[i + 1] = d.data[i + 2] = v;
            }
            var inv = new Uint8ClampedArray(d.data);
            for (var i = 0; i < inv.length; i += 4) {
                inv[i] = 255 - inv[i];
                inv[i + 1] = 255 - inv[i + 1];
                inv[i + 2] = 255 - inv[i + 2];
            }
            boxBlur(inv, w, h, 8);
            for (var i = 0; i < d.data.length; i += 4)
                for (var j = 0; j < 3; j++)
                    d.data[i + j] = inv[i + j] === 255 ? 255 : Math.min(255, (d.data[i + j] * 255) / (255 - inv[i + j]));
            c.putImageData(d, 0, 0);
        },
    },
    {
        id: 'watercolor', label: 'Акварел',
        apply: function (c, w, h) {
            var d = c.getImageData(0, 0, w, h);
            var o = new Uint8ClampedArray(d.data);
            // Multiple blur passes for painterly softness
            boxBlur(d.data, w, h, 3);
            boxBlur(d.data, w, h, 2);
            posterize(d.data, 16);
            boxBlur(d.data, w, h, 2);
            // Luminous, slightly warm watercolor tones
            for (var i = 0; i < d.data.length; i += 4) {
                var avg = (d.data[i] + d.data[i + 1] + d.data[i + 2]) / 3;
                d.data[i] = Math.min(255, Math.round(avg * 0.25 + d.data[i] * 0.75 + 14));
                d.data[i + 1] = Math.min(255, Math.round(avg * 0.25 + d.data[i + 1] * 0.75 + 9));
                d.data[i + 2] = Math.min(255, Math.round(avg * 0.25 + d.data[i + 2] * 0.75 + 4));
            }
            // Very soft edge suggestion
            var e = sobelEdges(o, w, h, 48);
            for (var i = 0; i < d.data.length; i += 4) {
                if (e[i] === 0) {
                    d.data[i] = Math.max(0, d.data[i] - 28);
                    d.data[i + 1] = Math.max(0, d.data[i + 1] - 28);
                    d.data[i + 2] = Math.max(0, d.data[i + 2] - 28);
                }
            }
            c.putImageData(d, 0, 0);
        },
    },
];
/* ═══════════════════════════════════════════════════
   SVG path helpers
   ═══════════════════════════════════════════════════ */
function rrPath(x, y, w, h, r) {
    var _a = [x + w, y + h], x2 = _a[0], y2 = _a[1];
    return "M".concat(x + r, ",").concat(y, " H").concat(x2 - r, " Q").concat(x2, ",").concat(y, " ").concat(x2, ",").concat(y + r, " V").concat(y2 - r, " Q").concat(x2, ",").concat(y2, " ").concat(x2 - r, ",").concat(y2, " H").concat(x + r, " Q").concat(x, ",").concat(y2, " ").concat(x, ",").concat(y2 - r, " V").concat(y + r, " Q").concat(x, ",").concat(y, " ").concat(x + r, ",").concat(y, " Z");
}
function ellPath(cx, cy, rx, ry) {
    return "M".concat(cx, ",").concat(cy - ry, " A").concat(rx, ",").concat(ry, ",0,0,0,").concat(cx, ",").concat(cy + ry, " A").concat(rx, ",").concat(ry, ",0,0,0,").concat(cx, ",").concat(cy - ry, " Z");
}
/* ── Oval ── */
function buildOvalShape(W, H) {
    var cx = W / 2, cy = H / 2;
    var rx1 = cx - 2, ry1 = cy - 2;
    var rx2 = cx - 4, ry2 = cy - 4;
    var rxD = cx - 14, ryD = cy - 14;
    var hcx = Math.round(cx);
    var hcy = Math.round(H * 0.4071);
    var hrx = Math.round(W * 0.245);
    var hry = Math.round(H * 0.2232);
    var hole = { cx: hcx, cy: hcy, rx: hrx, ry: hry };
    var holeStr = ellPath(hcx, hcy, hrx, hry);
    var outer1 = ellPath(cx, cy, rx1, ry1);
    var outer2 = ellPath(cx, cy, rx2, ry2);
    return {
        id: 'oval', label: 'Овал', vb: "0 0 ".concat(W, " ").concat(H), w: W, h: H,
        hole: hole,
        color: '#7B2323', resizable: true,
        renderBody: function (c, noHole) {
            var d = adjustBrightness(c, .7), r = adjustBrightness(c, .85);
            return (_jsxs(_Fragment, { children: [_jsx("path", { d: noHole ? outer1 : "".concat(outer1).concat(holeStr), fill: d, fillRule: "evenodd" }), _jsx("path", { d: noHole ? outer2 : "".concat(outer2).concat(holeStr), fill: c, fillRule: "evenodd" }), _jsx("ellipse", { cx: cx, cy: cy, rx: rxD, ry: ryD, fill: "none", stroke: r, strokeWidth: 1.5, opacity: .55 }), !noHole && _jsx("ellipse", { cx: hcx, cy: hcy, rx: hrx + 6, ry: hry + 6, fill: "none", stroke: r, strokeWidth: 1.5, opacity: .45 })] }));
        },
        drawBody: function (ctx, c, noHole) {
            var d = adjustBrightness(c, .7), r = adjustBrightness(c, .85);
            if (noHole) {
                ctx.beginPath();
                ctx.ellipse(cx, cy, rx1, ry1, 0, 0, Math.PI * 2);
                ctx.fillStyle = d;
                ctx.fill();
                ctx.beginPath();
                ctx.ellipse(cx, cy, rx2, ry2, 0, 0, Math.PI * 2);
                ctx.fillStyle = c;
                ctx.fill();
            }
            else {
                ctx.beginPath();
                ctx.ellipse(cx, cy, rx1, ry1, 0, 0, Math.PI * 2);
                ctx.ellipse(hcx, hcy, hrx, hry, 0, 0, Math.PI * 2, true);
                ctx.fillStyle = d;
                ctx.fill('evenodd');
                ctx.beginPath();
                ctx.ellipse(cx, cy, rx2, ry2, 0, 0, Math.PI * 2);
                ctx.ellipse(hcx, hcy, hrx, hry, 0, 0, Math.PI * 2, true);
                ctx.fillStyle = c;
                ctx.fill('evenodd');
            }
            ctx.strokeStyle = r;
            ctx.globalAlpha = .55;
            ctx.lineWidth = 1.5;
            ctx.beginPath();
            ctx.ellipse(cx, cy, rxD, ryD, 0, 0, Math.PI * 2);
            ctx.stroke();
            if (!noHole) {
                ctx.globalAlpha = .45;
                ctx.beginPath();
                ctx.ellipse(hcx, hcy, hrx + 6, hry + 6, 0, 0, Math.PI * 2);
                ctx.stroke();
            }
            ctx.globalAlpha = 1;
        },
    };
}
/* ── Medallion (circle) ── */
function buildMedallionShape(size) {
    var c = Math.floor(size / 2);
    var r1 = c - 2, r2 = c - 4, rD = c - 14;
    var hcy = Math.round(size * 0.47);
    var hr = Math.round(size * 0.2125);
    var hole = { cx: c, cy: hcy, rx: hr, ry: hr };
    var holeStr = ellPath(c, hcy, hr, hr);
    var outer1 = ellPath(c, c, r1, r1);
    var outer2 = ellPath(c, c, r2, r2);
    return {
        id: 'medallion', label: 'Кръг', vb: "0 0 ".concat(size, " ").concat(size), w: size, h: size,
        hole: hole,
        color: '#7B2323', resizable: true,
        renderBody: function (col, noHole) {
            var d = adjustBrightness(col, .7), rv = adjustBrightness(col, .85);
            return (_jsxs(_Fragment, { children: [_jsx("path", { d: noHole ? outer1 : "".concat(outer1).concat(holeStr), fill: d, fillRule: "evenodd" }), _jsx("path", { d: noHole ? outer2 : "".concat(outer2).concat(holeStr), fill: col, fillRule: "evenodd" }), _jsx("circle", { cx: c, cy: c, r: rD, fill: "none", stroke: rv, strokeWidth: 1.5, opacity: .55 }), !noHole && _jsx("circle", { cx: c, cy: hcy, r: hr + 6, fill: "none", stroke: rv, strokeWidth: 1.5, opacity: .45 })] }));
        },
        drawBody: function (ctx, col, noHole) {
            var d = adjustBrightness(col, .7), rv = adjustBrightness(col, .85);
            if (noHole) {
                ctx.beginPath();
                ctx.arc(c, c, r1, 0, Math.PI * 2);
                ctx.fillStyle = d;
                ctx.fill();
                ctx.beginPath();
                ctx.arc(c, c, r2, 0, Math.PI * 2);
                ctx.fillStyle = col;
                ctx.fill();
            }
            else {
                ctx.beginPath();
                ctx.arc(c, c, r1, 0, Math.PI * 2);
                ctx.ellipse(c, hcy, hr, hr, 0, 0, Math.PI * 2, true);
                ctx.fillStyle = d;
                ctx.fill('evenodd');
                ctx.beginPath();
                ctx.arc(c, c, r2, 0, Math.PI * 2);
                ctx.ellipse(c, hcy, hr, hr, 0, 0, Math.PI * 2, true);
                ctx.fillStyle = col;
                ctx.fill('evenodd');
            }
            ctx.strokeStyle = rv;
            ctx.globalAlpha = .55;
            ctx.lineWidth = 1.5;
            ctx.beginPath();
            ctx.arc(c, c, rD, 0, Math.PI * 2);
            ctx.stroke();
            if (!noHole) {
                ctx.globalAlpha = .45;
                ctx.beginPath();
                ctx.arc(c, hcy, hr + 6, 0, Math.PI * 2);
                ctx.stroke();
            }
            ctx.globalAlpha = 1;
        },
    };
}
/* ── Diamond ── */
function buildDiamondShape(W, H) {
    var cx = Math.round(W / 2), hm = Math.round(H / 2);
    var hcy = Math.round(H * 0.4615);
    var hr = Math.round(Math.min(W, H) * 0.2);
    var hole = { cx: cx, cy: hcy, rx: hr, ry: hr };
    var holeStr = ellPath(cx, hcy, hr, hr);
    var mkD = function (ox, oy) {
        return "M".concat(cx, ",").concat(8 + oy, " L").concat(W - 8 - ox, ",").concat(hm, " L").concat(cx, ",").concat(H - 8 - oy, " L").concat(8 + ox, ",").concat(hm, " Z");
    };
    var outerD = mkD(0, 0), innerD = mkD(6, 6);
    var decoD = "M".concat(cx, ",").concat(Math.round(H * 0.077), " L").concat(Math.round(W * 0.915), ",").concat(hm, " L").concat(cx, ",").concat(Math.round(H * 0.923), " L").concat(Math.round(W * 0.085), ",").concat(hm, " Z");
    return {
        id: 'diamond', label: 'Диамант', vb: "0 0 ".concat(W, " ").concat(H), w: W, h: H,
        hole: hole,
        color: '#1e2d4d', resizable: true,
        renderBody: function (c, noHole) {
            var d = adjustBrightness(c, .7), r = adjustBrightness(c, .85);
            return (_jsxs(_Fragment, { children: [_jsx("path", { d: noHole ? outerD : "".concat(outerD).concat(holeStr), fill: d, fillRule: "evenodd" }), _jsx("path", { d: noHole ? innerD : "".concat(innerD).concat(holeStr), fill: c, fillRule: "evenodd" }), _jsx("path", { d: decoD, fill: "none", stroke: r, strokeWidth: 1.5, opacity: .45 }), !noHole && _jsx("circle", { cx: cx, cy: hcy, r: hr + 7, fill: "none", stroke: r, strokeWidth: 1.5, opacity: .45 })] }));
        },
        drawBody: function (ctx, c, noHole) {
            var d = adjustBrightness(c, .7), r = adjustBrightness(c, .85);
            var dm = function (ox, oy) {
                ctx.moveTo(cx, 8 + oy);
                ctx.lineTo(W - 8 - ox, hm);
                ctx.lineTo(cx, H - 8 - oy);
                ctx.lineTo(8 + ox, hm);
                ctx.closePath();
            };
            if (noHole) {
                ctx.beginPath();
                dm(0, 0);
                ctx.fillStyle = d;
                ctx.fill();
                ctx.beginPath();
                dm(6, 6);
                ctx.fillStyle = c;
                ctx.fill();
            }
            else {
                ctx.beginPath();
                dm(0, 0);
                ctx.ellipse(cx, hcy, hr, hr, 0, 0, Math.PI * 2, true);
                ctx.fillStyle = d;
                ctx.fill('evenodd');
                ctx.beginPath();
                dm(6, 6);
                ctx.ellipse(cx, hcy, hr, hr, 0, 0, Math.PI * 2, true);
                ctx.fillStyle = c;
                ctx.fill('evenodd');
            }
            ctx.strokeStyle = r;
            ctx.globalAlpha = .45;
            ctx.lineWidth = 1.5;
            ctx.beginPath();
            dm(Math.round(W * 0.085), Math.round(H * 0.077));
            ctx.stroke();
            if (!noHole) {
                ctx.beginPath();
                ctx.arc(cx, hcy, hr + 7, 0, Math.PI * 2);
                ctx.stroke();
            }
            ctx.globalAlpha = 1;
        },
    };
}
/* ── Rect / Square ── */
function buildRectShape(id, label, W, H, defaultColor, equalHole) {
    if (equalHole === void 0) { equalHole = false; }
    var CR = Math.max(8, Math.min(18, Math.round(Math.min(W, H) * 0.038)));
    var HCX = Math.round(W / 2), HCY = Math.round(H * 0.46);
    var base = Math.round(Math.min(W, H) * 0.22);
    var HRX = equalHole ? base : Math.round(W * 0.195);
    var HRY = equalHole ? base : Math.round(H * 0.22);
    var hole = { cx: HCX, cy: HCY, rx: HRX, ry: HRY };
    var outerP = rrPath(2, 2, W - 4, H - 4, CR);
    var innerP = rrPath(4, 4, W - 8, H - 8, Math.max(4, CR - 2));
    var insetP = rrPath(12, 12, W - 24, H - 24, Math.max(2, CR - 6));
    var holeP = ellPath(HCX, HCY, HRX, HRY);
    return {
        id: id,
        label: label,
        resizable: true, vb: "0 0 ".concat(W, " ").concat(H), w: W, h: H,
        hole: hole,
        color: defaultColor,
        renderBody: function (c, noHole) {
            var d = adjustBrightness(c, .85), r = adjustBrightness(c, .7);
            return (_jsxs(_Fragment, { children: [_jsx("path", { d: noHole ? outerP : "".concat(outerP).concat(holeP), fill: d, fillRule: "evenodd" }), _jsx("path", { d: noHole ? innerP : "".concat(innerP).concat(holeP), fill: c, fillRule: "evenodd" }), _jsx("path", { d: insetP, fill: "none", stroke: r, strokeWidth: 1, opacity: .35 }), !noHole && _jsx("ellipse", { cx: HCX, cy: HCY, rx: HRX + 5, ry: HRY + 5, fill: "none", stroke: r, strokeWidth: 1, opacity: .35 })] }));
        },
        drawBody: function (ctx, c, noHole) {
            var d = adjustBrightness(c, .85), r = adjustBrightness(c, .7);
            if (noHole) {
                ctx.beginPath();
                ctx.roundRect(2, 2, W - 4, H - 4, CR);
                ctx.fillStyle = d;
                ctx.fill();
                ctx.beginPath();
                ctx.roundRect(4, 4, W - 8, H - 8, Math.max(4, CR - 2));
                ctx.fillStyle = c;
                ctx.fill();
            }
            else {
                ctx.beginPath();
                ctx.roundRect(2, 2, W - 4, H - 4, CR);
                ctx.ellipse(HCX, HCY, HRX, HRY, 0, 0, Math.PI * 2, true);
                ctx.fillStyle = d;
                ctx.fill('evenodd');
                ctx.beginPath();
                ctx.roundRect(4, 4, W - 8, H - 8, Math.max(4, CR - 2));
                ctx.ellipse(HCX, HCY, HRX, HRY, 0, 0, Math.PI * 2, true);
                ctx.fillStyle = c;
                ctx.fill('evenodd');
            }
            ctx.strokeStyle = r;
            ctx.globalAlpha = .35;
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.roundRect(12, 12, W - 24, H - 24, Math.max(2, CR - 6));
            ctx.stroke();
            if (!noHole) {
                ctx.beginPath();
                ctx.ellipse(HCX, HCY, HRX + 5, HRY + 5, 0, 0, Math.PI * 2);
                ctx.stroke();
            }
            ctx.globalAlpha = 1;
        },
    };
}
var THUMB_COLOR = '#7B2323';
var BASE_SHAPES = [
    buildOvalShape(400, 560),
    buildMedallionShape(400),
    buildDiamondShape(400, 520),
    buildRectShape('portrait', 'Вертикален', 340, 500, '#4a1942'),
    buildRectShape('square', 'Квадрат', 400, 400, '#2d2d2d', true),
    buildRectShape('rectangle', 'Хоризонтален', 500, 340, '#f5f0e6'),
];
/* ═══════════════════════════════════════════════════
   Catalog data
   ═══════════════════════════════════════════════════ */
var COLOR_PRESETS = ['#7B2323', '#2d5627', '#1e2d4d', '#3d1818', '#8B6914', '#2d2d2d', '#4a1942', '#1a4d4d', '#f5f0e6', '#8B4513'];
var LOGO_COLOR_PRESETS = ['#ffffff', '#f5f0e6', '#D4A574', '#FFD700', '#7B2323', '#2d5627', '#1e2d4d', '#2d2d2d'];
var DECO_CATEGORIES = [
    {
        id: 'rings', label: 'Пръстени',
        items: [
            { id: 'ring-1', label: 'Халки 1', src: '/label-creator/rings/ring-1.png' },
            { id: 'rings-1', label: 'Халки 2', src: '/label-creator/rings/rings-1.png' },
            { id: 'rings-3', label: 'Халки 3', src: '/label-creator/rings/rings-3.png' },
            { id: 'rings-4', label: 'Халки 4', src: '/label-creator/rings/rings-4.png' },
        ],
    },
    {
        id: 'champagne', label: 'Шампанско',
        items: [
            { id: 'champagne-1', label: 'Шампанско 1', src: '/label-creator/champagne/champagne-1.png' },
            { id: 'champagne-3', label: 'Шампанско 2', src: '/label-creator/champagne/champagne-3.png' },
            { id: 'champagne-4', label: 'Шампанско 3', src: '/label-creator/champagne/champagne-4.png' },
        ],
    },
    {
        id: 'floral-arches', label: 'Цветни арки',
        items: [
            { id: 'wreath-1', label: 'Венец 1', src: '/label-creator/floral-arches/wreath-1.png' },
            { id: 'wreath-2', label: 'Венец 2', src: '/label-creator/floral-arches/wreath-2.png' },
            { id: 'wreath-4', label: 'Венец 3', src: '/label-creator/floral-arches/wreath-4.png' },
            { id: 'wreath-5', label: 'Венец 4', src: '/label-creator/floral-arches/wreath-5.png' },
            { id: 'wreath-6', label: 'Венец 5', src: '/label-creator/floral-arches/wreath-6.png' },
            { id: 'wreath-7', label: 'Венец 6', src: '/label-creator/floral-arches/wreath-7.png' },
            { id: 'wreath-9', label: 'Венец 7', src: '/label-creator/floral-arches/wreath-9.png' },
            { id: 'wreath-10', label: 'Венец 8', src: '/label-creator/floral-arches/wreath-10.png' },
            { id: 'wreath-11', label: 'Венец 9', src: '/label-creator/floral-arches/wreath-11.png' },
            { id: 'wreath-12', label: 'Венец 10', src: '/label-creator/floral-arches/wreath-12.png' },
            { id: 'wreath-13', label: 'Венец 11', src: '/label-creator/floral-arches/wreath-13.png' },
        ],
    },
    {
        id: 'costumes', label: 'Костюми и рокли',
        items: [
            { id: 'suit-1', label: 'Костюм 1', src: '/label-creator/costumes/suit-1.png' },
            { id: 'suit', label: 'Костюм 2', src: '/label-creator/costumes/suit.png' },
            { id: 'tuxedo-4', label: 'Смокинг', src: '/label-creator/costumes/tuxedo-4.png' },
            { id: 'dress', label: 'Рокля 1', src: '/label-creator/costumes/wedding-dress.png' },
            { id: 'dress-2', label: 'Рокля 2', src: '/label-creator/costumes/wedding-dress-2.png' },
            { id: 'dress-3', label: 'Рокля 3', src: '/label-creator/costumes/wedding-dress-3.png' },
            { id: 'dress-4', label: 'Рокля 4', src: '/label-creator/costumes/wedding-dress-4.png' },
        ],
    },
    {
        id: 'decorations', label: 'Декорации',
        items: [
            { id: 'flowers-2', label: 'Цветя 1', src: '/label-creator/decorations/flowers-2.png' },
            { id: 'flowers-3', label: 'Цветя 2', src: '/label-creator/decorations/flowers-3.png' },
            { id: 'hearts-2', label: 'Сърца', src: '/label-creator/decorations/hearts-2.png' },
            { id: 'ribbon-2', label: 'Лента', src: '/label-creator/decorations/ribbon-2.png' },
            { id: 'wedding-flowers-6', label: 'Цветя 3', src: '/label-creator/decorations/wedding-flowers-6.png' },
        ],
    },
    {
        id: 'other', label: 'Други',
        items: [
            { id: 'hearts-1', label: 'Сърца 2', src: '/label-creator/other/hearts-1.png' },
            { id: 'lovebox-1', label: 'Кутия', src: '/label-creator/other/lovebox-1.png' },
            { id: 'tree', label: 'Дърво', src: '/label-creator/other/tree.png' },
        ],
    },
];
var FONT_OPTIONS = [
    { value: "'Playfair Display', serif", label: 'Playfair Display' },
    { value: "'Marck Script', cursive", label: 'Marck Script' },
    { value: "'Bad Script', cursive", label: 'Bad Script' },
    { value: "'Philosopher', serif", label: 'Philosopher' },
    { value: "'Kurale', serif", label: 'Kurale' },
];
var STEPS = [
    { n: 1, label: 'Форма' },
    { n: 2, label: 'Цвят' },
    { n: 3, label: 'Снимка' },
    { n: 4, label: 'Лого' },
    { n: 5, label: 'Декорации' },
    { n: 6, label: 'Текст' },
];
var FRAME_OPTIONS = [
    { id: 'ellipse', label: 'Овал' },
    { id: 'circle', label: 'Кръг' },
    { id: 'square', label: 'Квадрат' },
    { id: 'rect', label: 'Правоъгълник' },
];
var _uid = 0;
var uid = function () { return 'u' + (++_uid); };
var LOGO_BASE_W = 120, LOGO_BASE_H = 42;
var DECO_SIZE = 60;
/* ── Arc text canvas helper ── */
function drawArcTextCanvas(ctx, t) {
    var fontStr = "".concat(t.italic ? 'italic ' : '').concat(t.bold ? 'bold ' : '').concat(t.fontSize, "px ").concat(t.fontFamily);
    ctx.font = fontStr;
    ctx.fillStyle = t.color;
    var chars = Array.from(t.content);
    if (!chars.length)
        return;
    var charWidths = chars.map(function (ch) { return ctx.measureText(ch).width; });
    var totalWidth = charWidths.reduce(function (s, w) { return s + w; }, 0);
    var r = t.arcRadius;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    if (t.arcDirection === 'top') {
        // Circle center: (t.x, t.y + r). Arc apex at angle -π/2 from center = (t.x, t.y).
        // Characters go left-to-right (increasing angle from -π/2 - halfSpan to -π/2 + halfSpan).
        var cx = t.x, cy = t.y + r;
        var angle = -Math.PI / 2 - totalWidth / (2 * r);
        for (var i = 0; i < chars.length; i++) {
            var charAngle = angle + charWidths[i] / (2 * r);
            ctx.save();
            ctx.translate(cx + r * Math.cos(charAngle), cy + r * Math.sin(charAngle));
            ctx.rotate(charAngle + Math.PI / 2);
            ctx.fillText(chars[i], 0, 0);
            ctx.restore();
            angle += charWidths[i] / r;
        }
    }
    else {
        // Circle center: (t.x, t.y - r). Arc nadir at angle +π/2 from center = (t.x, t.y).
        // Characters go left-to-right with DECREASING angle (from π/2 + halfSpan down to π/2 - halfSpan).
        var cx = t.x, cy = t.y - r;
        var angle = Math.PI / 2 + totalWidth / (2 * r);
        for (var i = 0; i < chars.length; i++) {
            var charAngle = angle - charWidths[i] / (2 * r);
            ctx.save();
            ctx.translate(cx + r * Math.cos(charAngle), cy + r * Math.sin(charAngle));
            ctx.rotate(charAngle - Math.PI / 2);
            ctx.fillText(chars[i], 0, 0);
            ctx.restore();
            angle -= charWidths[i] / r;
        }
    }
}
/* ═══════════════════════════════════════════════════
   Component
   ═══════════════════════════════════════════════════ */
var LabelsPage = function () {
    var _a, _b, _c, _d;
    var _e = useState('bg'), language = _e[0], setLanguage = _e[1];
    var _f = useState(1), step = _f[0], setStep = _f[1];
    var _g = useState('oval'), shapeId = _g[0], setShapeId = _g[1];
    // Resizable shape dimensions — all shapes
    var _h = useState(400), ovalW = _h[0], setOvalW = _h[1];
    var _j = useState(560), ovalH = _j[0], setOvalH = _j[1];
    var _k = useState(400), medallionSize = _k[0], setMedallionSize = _k[1];
    var _l = useState(400), diamondW = _l[0], setDiamondW = _l[1];
    var _m = useState(520), diamondH = _m[0], setDiamondH = _m[1];
    var _o = useState(500), horizW = _o[0], setHorizW = _o[1];
    var _p = useState(340), horizH = _p[0], setHorizH = _p[1];
    var _q = useState(400), squareSize = _q[0], setSquareSize = _q[1];
    var _r = useState(340), vertW = _r[0], setVertW = _r[1];
    var _s = useState(500), vertH = _s[0], setVertH = _s[1];
    // Color
    var _t = useState('#7B2323'), labelColor = _t[0], setLabelColor = _t[1];
    var _u = useState('#7B2323'), colorInput = _u[0], setColorInput = _u[1];
    // Photo
    var _v = useState(true), wantPhoto = _v[0], setWantPhoto = _v[1];
    var _w = useState('ellipse'), frameType = _w[0], setFrameType = _w[1];
    var _x = useState(0), frameW = _x[0], setFrameW = _x[1];
    var _y = useState(0), frameH = _y[0], setFrameH = _y[1];
    var _z = useState(null), photo = _z[0], setPhoto = _z[1];
    var _0 = useState(null), origPhoto = _0[0], setOrigPhoto = _0[1];
    var _1 = useState({ x: 0, y: 0 }), photoPos = _1[0], setPhotoPos = _1[1];
    var _2 = useState(1), photoScale = _2[0], setPhotoScale = _2[1];
    var _3 = useState(1), photoBase = _3[0], setPhotoBase = _3[1];
    var _4 = useState({ w: 0, h: 0 }), photoNat = _4[0], setPhotoNat = _4[1];
    var _5 = useState(null), cartoonId = _5[0], setCartoonId = _5[1];
    var _6 = useState(false), processing = _6[0], setProcessing = _6[1];
    // Logo
    var _7 = useState(false), showLogo = _7[0], setShowLogo = _7[1];
    var _8 = useState(0), logoX = _8[0], setLogoX = _8[1];
    var _9 = useState(0), logoY = _9[0], setLogoY = _9[1];
    var _10 = useState(1.0), logoScale = _10[0], setLogoScale = _10[1];
    var _11 = useState(''), logoColor = _11[0], setLogoColor = _11[1];
    var _12 = useState(''), logoColorInput = _12[0], setLogoColorInput = _12[1];
    // Decorations
    var _13 = useState('rings'), activeDecoCategory = _13[0], setActiveDecoCategory = _13[1];
    var _14 = useState([]), decos = _14[0], setDecos = _14[1];
    var _15 = useState(-1), activeDecoIdx = _15[0], setActiveDecoIdx = _15[1];
    // Text
    var _16 = useState([]), texts = _16[0], setTexts = _16[1];
    var _17 = useState(-1), activeTextIdx = _17[0], setActiveTextIdx = _17[1];
    var svgRef = useRef(null);
    var fileRef = useRef(null);
    var decoFileRef = useRef(null);
    var dragging = useRef(false);
    var dragTarget = useRef(null);
    var dragStart = useRef({ x: 0, y: 0, ix: 0, iy: 0 });
    var stateRef = useRef({ photoScale: photoScale, photoPos: photoPos, photoNat: photoNat });
    stateRef.current = { photoScale: photoScale, photoPos: photoPos, photoNat: photoNat };
    // RAF throttle: only commit one setState per animation frame during drag
    var rafId = useRef(null);
    var pendingPos = useRef(null);
    /* ── computed shape ── */
    var shape = useMemo(function () {
        if (shapeId === 'oval')
            return buildOvalShape(ovalW, ovalH);
        if (shapeId === 'medallion')
            return buildMedallionShape(medallionSize);
        if (shapeId === 'diamond')
            return buildDiamondShape(diamondW, diamondH);
        if (shapeId === 'rectangle')
            return buildRectShape('rectangle', 'Хоризонтален', horizW, horizH, '#f5f0e6');
        if (shapeId === 'square')
            return buildRectShape('square', 'Квадрат', squareSize, squareSize, '#2d2d2d', true);
        if (shapeId === 'portrait')
            return buildRectShape('portrait', 'Вертикален', vertW, vertH, '#4a1942');
        return buildOvalShape(ovalW, ovalH);
    }, [shapeId, ovalW, ovalH, medallionSize, diamondW, diamondH, horizW, horizH, squareSize, vertW, vertH]);
    /* ── frame clip dims ── */
    var cfRX = frameW > 0 ? frameW : shape.hole.rx;
    var cfRY = (frameType === 'circle' || frameType === 'square') ? cfRX : (frameH > 0 ? frameH : shape.hole.ry);
    /* ── on shape change: reset frame + logo position ── */
    useEffect(function () {
        setFrameW(0);
        setFrameH(0);
        setFrameType('ellipse');
        setLogoX(shape.hole.cx);
        setLogoY(shape.hole.cy + shape.hole.ry + 45);
    }, [shapeId]); // eslint-disable-line react-hooks/exhaustive-deps
    /* ── color input ── */
    useEffect(function () { setColorInput(labelColor); }, [labelColor]);
    var handleColorInput = useCallback(function (val) {
        var v = val.startsWith('#') ? val : '#' + val;
        setColorInput(v);
        if (/^#[0-9a-fA-F]{6}$/.test(v))
            setLabelColor(v);
    }, []);
    var handleLogoColorInput = useCallback(function (val) {
        var v = val.startsWith('#') ? val : '#' + val;
        setLogoColorInput(v);
        if (v === '#' || v === '') {
            setLogoColor('');
            setLogoColorInput('');
            return;
        }
        if (/^#[0-9a-fA-F]{6}$/.test(v))
            setLogoColor(v);
    }, []);
    /* ── upload photo ── */
    var centerPhoto = useCallback(function (nw, nh, hole) {
        var sc = Math.max((hole.rx * 2) / nw, (hole.ry * 2) / nh);
        setPhotoBase(sc);
        setPhotoScale(sc);
        setPhotoPos({ x: hole.cx - (nw * sc) / 2, y: hole.cy - (nh * sc) / 2 });
    }, []);
    var handleUpload = useCallback(function (e) {
        var _a;
        var f = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!f)
            return;
        var reader = new FileReader();
        reader.onload = function () {
            var url = reader.result;
            var img = new Image();
            img.onload = function () {
                setPhotoNat({ w: img.naturalWidth, h: img.naturalHeight });
                setPhoto(url);
                setOrigPhoto(url);
                setCartoonId(null);
                var rx = frameW > 0 ? frameW : shape.hole.rx;
                var ry = (frameType === 'circle' || frameType === 'square') ? rx : (frameH > 0 ? frameH : shape.hole.ry);
                centerPhoto(img.naturalWidth, img.naturalHeight, { cx: shape.hole.cx, cy: shape.hole.cy, rx: rx, ry: ry });
            };
            img.src = url;
        };
        reader.readAsDataURL(f);
        e.target.value = '';
    }, [shape.hole, frameW, frameH, frameType, centerPhoto]);
    var handleDecoUpload = useCallback(function (e) {
        var _a;
        var f = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!f)
            return;
        var reader = new FileReader();
        reader.onload = function () {
            var src = reader.result;
            var name = f.name.replace(/\.[^.]+$/, '');
            var d = { uid: uid(), catalogId: 'custom', src: src, label: name, x: shape.hole.cx, y: shape.hole.cy + shape.hole.ry + 50, scale: 1 };
            setDecos(function (prev) { setActiveDecoIdx(prev.length); return __spreadArray(__spreadArray([], prev, true), [d], false); });
        };
        reader.readAsDataURL(f);
        e.target.value = '';
    }, [shape]);
    /* ── unified drag ── */
    var beginDrag = useCallback(function (e, target, ix, iy) {
        var cl = 'clientX' in e ? e : e.touches[0];
        if (!cl)
            return;
        e.preventDefault();
        dragging.current = true;
        dragTarget.current = target;
        dragStart.current = { x: cl.clientX, y: cl.clientY, ix: ix, iy: iy };
    }, []);
    var onSvgPointerDown = useCallback(function (e) {
        if (step === 3 && wantPhoto && photo)
            beginDrag(e, 'photo', stateRef.current.photoPos.x, stateRef.current.photoPos.y);
    }, [step, wantPhoto, photo, beginDrag]);
    useEffect(function () {
        var move = function (e) {
            var _a;
            if (!dragging.current || !svgRef.current)
                return;
            e.preventDefault();
            var cl = 'clientX' in e ? e : (_a = e.touches) === null || _a === void 0 ? void 0 : _a[0];
            if (!cl)
                return;
            var r = svgRef.current.getBoundingClientRect();
            var sx = shape.w / r.width, sy = shape.h / r.height;
            // Store latest position in ref — no setState yet
            pendingPos.current = {
                nx: dragStart.current.ix + (cl.clientX - dragStart.current.x) * sx,
                ny: dragStart.current.iy + (cl.clientY - dragStart.current.y) * sy,
            };
            // Schedule exactly one RAF commit per frame
            if (rafId.current === null) {
                rafId.current = requestAnimationFrame(function () {
                    rafId.current = null;
                    var p = pendingPos.current;
                    if (!p || !dragging.current)
                        return;
                    pendingPos.current = null;
                    var tgt = dragTarget.current;
                    if (tgt === 'photo')
                        setPhotoPos({ x: p.nx, y: p.ny });
                    else if (tgt === 'logo') {
                        setLogoX(p.nx);
                        setLogoY(p.ny);
                    }
                    else if (tgt === null || tgt === void 0 ? void 0 : tgt.startsWith('deco-')) {
                        var idx_1 = parseInt(tgt.slice(5));
                        setDecos(function (prev) { return prev.map(function (d, i) { return i === idx_1 ? __assign(__assign({}, d), { x: p.nx, y: p.ny }) : d; }); });
                    }
                    else if (tgt === null || tgt === void 0 ? void 0 : tgt.startsWith('text-')) {
                        var idx_2 = parseInt(tgt.slice(5));
                        setTexts(function (prev) { return prev.map(function (t, i) { return i === idx_2 ? __assign(__assign({}, t), { x: p.nx, y: p.ny }) : t; }); });
                    }
                });
            }
        };
        var up = function () {
            dragging.current = false;
            dragTarget.current = null;
            if (rafId.current !== null) {
                cancelAnimationFrame(rafId.current);
                rafId.current = null;
            }
            pendingPos.current = null;
        };
        window.addEventListener('mousemove', move);
        window.addEventListener('mouseup', up);
        window.addEventListener('touchmove', move, { passive: false });
        window.addEventListener('touchend', up);
        return function () { window.removeEventListener('mousemove', move); window.removeEventListener('mouseup', up); window.removeEventListener('touchmove', move); window.removeEventListener('touchend', up); };
    }, [shape.w, shape.h]);
    /* ── wheel zoom ── */
    useEffect(function () {
        var el = svgRef.current;
        if (!el)
            return;
        var handler = function (e) {
            var f = e.deltaY > 0 ? .94 : 1.06;
            if (step === 3 && wantPhoto && photo) {
                e.preventDefault();
                var _a = stateRef.current, sc = _a.photoScale, pos = _a.photoPos;
                var ns = Math.max(photoBase * .15, sc * f), ratio = ns / sc;
                setPhotoScale(ns);
                setPhotoPos({ x: shape.hole.cx - (shape.hole.cx - pos.x) * ratio, y: shape.hole.cy - (shape.hole.cy - pos.y) * ratio });
            }
            else if (step === 4 && showLogo) {
                e.preventDefault();
                setLogoScale(function (prev) { return Math.max(0.3, Math.min(3, prev * f)); });
            }
            else if (step === 5 && activeDecoIdx >= 0) {
                e.preventDefault();
                var idx_3 = activeDecoIdx;
                setDecos(function (prev) { return prev.map(function (d, i) { return i === idx_3 ? __assign(__assign({}, d), { scale: Math.max(0.1, Math.min(12, d.scale * f)) }) : d; }); });
            }
            else if (step === 6 && activeTextIdx >= 0) {
                e.preventDefault();
                var idx_4 = activeTextIdx;
                setTexts(function (prev) { return prev.map(function (t, i) { return i === idx_4 ? __assign(__assign({}, t), { fontSize: Math.max(8, Math.min(72, Math.round(t.fontSize * (e.deltaY > 0 ? 0.95 : 1.05)))) }) : t; }); });
            }
        };
        el.addEventListener('wheel', handler, { passive: false });
        return function () { return el.removeEventListener('wheel', handler); };
    }, [step, wantPhoto, photo, photoBase, showLogo, activeDecoIdx, activeTextIdx, shape.hole]); // eslint-disable-line react-hooks/exhaustive-deps
    var handleSlider = useCallback(function (e) {
        var ns = parseFloat(e.target.value), _a = stateRef.current, sc = _a.photoScale, pos = _a.photoPos, ratio = ns / sc;
        setPhotoScale(ns);
        setPhotoPos({ x: shape.hole.cx - (shape.hole.cx - pos.x) * ratio, y: shape.hole.cy - (shape.hole.cy - pos.y) * ratio });
    }, [shape.hole]);
    /* ── cartoonize ── */
    var applyCartoon = useCallback(function (sid) { return __awaiter(void 0, void 0, void 0, function () {
        var s, img;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!origPhoto)
                        return [2 /*return*/];
                    setProcessing(true);
                    setCartoonId(sid);
                    return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, 30); })];
                case 1:
                    _a.sent();
                    s = CSTYLES.find(function (x) { return x.id === sid; });
                    if (!s) {
                        setProcessing(false);
                        return [2 /*return*/];
                    }
                    img = new Image();
                    img.onload = function () {
                        var M = 800;
                        var w = img.naturalWidth, h = img.naturalHeight;
                        if (w > M || h > M) {
                            var r = Math.min(M / w, M / h);
                            w = Math.round(w * r);
                            h = Math.round(h * r);
                        }
                        var cv = document.createElement('canvas');
                        cv.width = w;
                        cv.height = h;
                        var cx = cv.getContext('2d');
                        cx.drawImage(img, 0, 0, w, h);
                        s.apply(cx, w, h);
                        setPhoto(cv.toDataURL('image/png'));
                        setProcessing(false);
                    };
                    img.src = origPhoto;
                    return [2 /*return*/];
            }
        });
    }); }, [origPhoto]);
    var resetCartoon = useCallback(function () { if (origPhoto) {
        setPhoto(origPhoto);
        setCartoonId(null);
    } }, [origPhoto]);
    /* ── decorations ── */
    var addDeco = useCallback(function (item) {
        var d = { uid: uid(), catalogId: item.id, src: item.src, label: item.label, x: shape.hole.cx, y: shape.hole.cy + shape.hole.ry + 50, scale: 1 };
        setDecos(function (prev) { setActiveDecoIdx(prev.length); return __spreadArray(__spreadArray([], prev, true), [d], false); });
    }, [shape]);
    var updateDeco = useCallback(function (idx, patch) { return setDecos(function (prev) { return prev.map(function (d, i) { return i === idx ? __assign(__assign({}, d), patch) : d; }); }); }, []);
    var removeDeco = useCallback(function (idx) { setDecos(function (prev) { return prev.filter(function (_, i) { return i !== idx; }); }); setActiveDecoIdx(-1); }, []);
    /* ── text ── */
    var addText = useCallback(function () {
        var t = {
            uid: uid(), content: 'Текст', x: shape.hole.cx, y: shape.hole.cy,
            fontSize: 22, fontFamily: "'Playfair Display', serif", color: '#ffffff', bold: false, italic: false,
            arcEnabled: false, arcRadius: shape.hole.rx + 40, arcDirection: 'top',
        };
        setTexts(function (prev) { setActiveTextIdx(prev.length); return __spreadArray(__spreadArray([], prev, true), [t], false); });
    }, [shape]);
    var updateText = useCallback(function (idx, patch) { return setTexts(function (prev) { return prev.map(function (t, i) { return i === idx ? __assign(__assign({}, t), patch) : t; }); }); }, []);
    var removeText = useCallback(function (idx) { setTexts(function (prev) { return prev.filter(function (_, i) { return i !== idx; }); }); setActiveTextIdx(-1); }, []);
    /* ── shape selection ── */
    var DEFAULT_COLORS = { oval: '#7B2323', medallion: '#7B2323', diamond: '#1e2d4d', portrait: '#4a1942', square: '#2d2d2d', rectangle: '#f5f0e6' };
    var selectShape = useCallback(function (id) {
        setShapeId(id);
        if (DEFAULT_COLORS[id])
            setLabelColor(DEFAULT_COLORS[id]);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    /* ── download ── */
    var handleDownload = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var S, cv, ctx, img, _a, p, sc, n, lc, lctx, _b, hx, hy, ringColorDl, li, lw, lh, _loop_1, _i, decos_1, d, link;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    S = 3, cv = document.createElement('canvas');
                    cv.width = shape.w * S;
                    cv.height = shape.h * S;
                    ctx = cv.getContext('2d');
                    ctx.scale(S, S);
                    if (!(wantPhoto && photo)) return [3 /*break*/, 2];
                    return [4 /*yield*/, new Promise(function (res) { var i = new Image(); i.onload = function () { return res(i); }; i.src = photo; })];
                case 1:
                    img = _c.sent();
                    ctx.save();
                    ctx.beginPath();
                    if (frameType === 'ellipse')
                        ctx.ellipse(shape.hole.cx, shape.hole.cy, cfRX, cfRY, 0, 0, Math.PI * 2);
                    else if (frameType === 'circle')
                        ctx.arc(shape.hole.cx, shape.hole.cy, cfRX, 0, Math.PI * 2);
                    else
                        ctx.roundRect(shape.hole.cx - cfRX, shape.hole.cy - cfRY, cfRX * 2, cfRY * 2, 4);
                    ctx.clip();
                    _a = stateRef.current, p = _a.photoPos, sc = _a.photoScale, n = _a.photoNat;
                    ctx.drawImage(img, p.x, p.y, n.w * sc, n.h * sc);
                    ctx.restore();
                    _c.label = 2;
                case 2:
                    lc = document.createElement('canvas');
                    lc.width = shape.w * S;
                    lc.height = shape.h * S;
                    lctx = lc.getContext('2d');
                    lctx.scale(S, S);
                    shape.drawBody(lctx, labelColor, true);
                    lctx.globalCompositeOperation = 'destination-out';
                    lctx.beginPath();
                    _b = shape.hole, hx = _b.cx, hy = _b.cy;
                    if (wantPhoto) {
                        if (frameType === 'ellipse')
                            lctx.ellipse(hx, hy, cfRX, cfRY, 0, 0, Math.PI * 2);
                        else if (frameType === 'circle')
                            lctx.arc(hx, hy, cfRX, 0, Math.PI * 2);
                        else
                            lctx.roundRect(hx - cfRX, hy - cfRY, cfRX * 2, cfRY * 2, 4);
                        lctx.fillStyle = 'black';
                        lctx.fill();
                    }
                    lctx.globalCompositeOperation = 'source-over';
                    ctx.drawImage(lc, 0, 0, shape.w, shape.h);
                    // Decorative ring — only when wantPhoto
                    if (wantPhoto) {
                        ringColorDl = adjustBrightness(labelColor, 0.6);
                        ctx.strokeStyle = ringColorDl;
                        ctx.globalAlpha = 0.5;
                        ctx.lineWidth = 1.5;
                        ctx.beginPath();
                        if (frameType === 'ellipse')
                            ctx.ellipse(hx, hy, cfRX + 4, cfRY + 4, 0, 0, Math.PI * 2);
                        else if (frameType === 'circle')
                            ctx.arc(hx, hy, cfRX + 4, 0, Math.PI * 2);
                        else
                            ctx.roundRect(hx - cfRX - 4, hy - cfRY - 4, (cfRX + 4) * 2, (cfRY + 4) * 2, 6);
                        ctx.stroke();
                        ctx.globalAlpha = 1;
                    }
                    if (!showLogo) return [3 /*break*/, 4];
                    return [4 /*yield*/, new Promise(function (res) { var i = new Image(); i.onload = function () { return res(i); }; i.src = withVersion('/images/logo_resized.svg'); })];
                case 3:
                    li = _c.sent();
                    lw = LOGO_BASE_W * logoScale, lh = LOGO_BASE_H * logoScale;
                    ctx.globalAlpha = 0.85;
                    ctx.drawImage(li, logoX - lw / 2, logoY - lh / 2, lw, lh);
                    ctx.globalAlpha = 1;
                    _c.label = 4;
                case 4:
                    _loop_1 = function (d) {
                        var di, sz, aspect, dw_1, dh_1;
                        return __generator(this, function (_d) {
                            switch (_d.label) {
                                case 0: return [4 /*yield*/, new Promise(function (res) { var i = new Image(); i.onload = function () { return res(i); }; i.src = d.src; })];
                                case 1:
                                    di = _d.sent();
                                    sz = DECO_SIZE * d.scale;
                                    aspect = di.naturalWidth / di.naturalHeight;
                                    dw_1 = aspect >= 1 ? sz : sz * aspect;
                                    dh_1 = aspect >= 1 ? sz / aspect : sz;
                                    ctx.drawImage(di, d.x - dw_1 / 2, d.y - dh_1 / 2, dw_1, dh_1);
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _i = 0, decos_1 = decos;
                    _c.label = 5;
                case 5:
                    if (!(_i < decos_1.length)) return [3 /*break*/, 8];
                    d = decos_1[_i];
                    return [5 /*yield**/, _loop_1(d)];
                case 6:
                    _c.sent();
                    _c.label = 7;
                case 7:
                    _i++;
                    return [3 /*break*/, 5];
                case 8:
                    texts.forEach(function (t) {
                        if (t.arcEnabled) {
                            drawArcTextCanvas(ctx, t);
                        }
                        else {
                            ctx.font = "".concat(t.italic ? 'italic ' : '').concat(t.bold ? 'bold ' : '').concat(t.fontSize, "px ").concat(t.fontFamily);
                            ctx.fillStyle = t.color;
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'middle';
                            ctx.fillText(t.content, t.x, t.y);
                        }
                    });
                    link = document.createElement('a');
                    link.download = 'kamea-label.png';
                    link.href = cv.toDataURL('image/png');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    return [2 /*return*/];
            }
        });
    }); }, [photo, wantPhoto, shape, labelColor, frameType, cfRX, cfRY, showLogo, logoX, logoY, logoScale, decos, texts]);
    /* ── computed ── */
    var dw = photoNat.w * photoScale, dh = photoNat.h * photoScale;
    var logoW = LOGO_BASE_W * logoScale, logoH = LOGO_BASE_H * logoScale;
    var ringColor = adjustBrightness(labelColor, 0.6);
    /* ═══════════════════════════════════════════════════ */
    return (_jsx(CartProvider, { children: _jsxs("div", { className: "lbl-page", children: [_jsx(NavBar, { activeTab: "", language: language, onLanguageChange: setLanguage }), _jsx(CartModal, { language: language }), _jsxs("div", { className: "lbl-brand-bar", children: [_jsx("span", { className: "lbl-brand-orn", children: "\u2767" }), _jsx("h1", { className: "lbl-brand-title", children: "\u0421\u044A\u0437\u0434\u0430\u0439\u0442\u0435 \u0441\u0432\u043E\u044F \u0441\u0432\u0430\u0442\u0431\u0435\u043D \u0435\u0442\u0438\u043A\u0435\u0442" }), _jsx("span", { className: "lbl-brand-orn", children: "\u2766" })] }), _jsx("nav", { className: "lbl-steps", children: STEPS.map(function (s, i) { return (_jsxs(React.Fragment, { children: [i > 0 && _jsx("span", { className: "lbl-step-line".concat(step > s.n ? ' done' : '') }), _jsxs("button", { className: "lbl-step-pill".concat(step === s.n ? ' active' : '').concat(step > s.n ? ' done' : ''), onClick: function () { return setStep(s.n); }, children: [_jsx("span", { className: "lbl-step-num", children: step > s.n ? '✓' : s.n }), _jsx("span", { className: "lbl-step-label", children: s.label })] })] }, s.n)); }) }), _jsxs("div", { className: "lbl-main", children: [_jsx("div", { className: "lbl-preview-area", children: _jsx("div", { className: "lbl-preview-card", style: { aspectRatio: "".concat(shape.w, "/").concat(shape.h) }, children: _jsxs("svg", { ref: svgRef, viewBox: shape.vb, className: "lbl-svg", style: { cursor: step === 3 && wantPhoto && photo ? 'grab' : 'default' }, onMouseDown: onSvgPointerDown, onTouchStart: onSvgPointerDown, children: [_jsxs("defs", { children: [_jsxs("clipPath", { id: "holeClip", children: [frameType === 'ellipse' && _jsx("ellipse", { cx: shape.hole.cx, cy: shape.hole.cy, rx: cfRX, ry: cfRY }), frameType === 'circle' && _jsx("circle", { cx: shape.hole.cx, cy: shape.hole.cy, r: cfRX }), (frameType === 'square' || frameType === 'rect') && _jsx("rect", { x: shape.hole.cx - cfRX, y: shape.hole.cy - cfRY, width: cfRX * 2, height: cfRY * 2, rx: 4 })] }), wantPhoto && (_jsxs("mask", { id: "labelMask", children: [_jsx("rect", { x: 0, y: 0, width: shape.w, height: shape.h, fill: "white" }), frameType === 'ellipse' && _jsx("ellipse", { cx: shape.hole.cx, cy: shape.hole.cy, rx: cfRX, ry: cfRY, fill: "black" }), frameType === 'circle' && _jsx("circle", { cx: shape.hole.cx, cy: shape.hole.cy, r: cfRX, fill: "black" }), (frameType === 'square' || frameType === 'rect') && _jsx("rect", { x: shape.hole.cx - cfRX, y: shape.hole.cy - cfRY, width: cfRX * 2, height: cfRY * 2, rx: 4, fill: "black" })] })), logoColor && (_jsxs("filter", { id: "logoColorFilter", colorInterpolationFilters: "sRGB", children: [_jsx("feFlood", { floodColor: logoColor, result: "color" }), _jsx("feComposite", { in: "color", in2: "SourceAlpha", operator: "in" })] })), texts.filter(function (t) { return t.arcEnabled; }).map(function (t) {
                                                    var r = t.arcRadius;
                                                    // t.y is the visual midpoint of the text (arc apex).
                                                    // Chord sits r BELOW for top-arc, r ABOVE for bottom-arc.
                                                    // SVG y-down: sweep=1 = clockwise on screen = goes UP from left → through apex (top)
                                                    //             sweep=0 = counterclockwise on screen = goes DOWN from left → through nadir (bottom)
                                                    var chordY = t.arcDirection === 'top' ? t.y + r : t.y - r;
                                                    var sweep = t.arcDirection === 'top' ? 1 : 0;
                                                    return (_jsx("path", { id: "arc-path-".concat(t.uid), fill: "none", d: "M ".concat(t.x - r, ",").concat(chordY, " A ").concat(r, ",").concat(r, ",0,0,").concat(sweep, ",").concat(t.x + r, ",").concat(chordY) }, "arc-".concat(t.uid)));
                                                })] }), wantPhoto && !photo && (_jsxs("g", { children: [frameType === 'ellipse' && _jsx("ellipse", { cx: shape.hole.cx, cy: shape.hole.cy, rx: cfRX, ry: cfRY, fill: "#f8f4ec" }), frameType === 'circle' && _jsx("circle", { cx: shape.hole.cx, cy: shape.hole.cy, r: cfRX, fill: "#f8f4ec" }), (frameType === 'square' || frameType === 'rect') && _jsx("rect", { x: shape.hole.cx - cfRX, y: shape.hole.cy - cfRY, width: cfRX * 2, height: cfRY * 2, rx: 4, fill: "#f8f4ec" }), _jsx("text", { x: shape.hole.cx, y: shape.hole.cy, textAnchor: "middle", dominantBaseline: "middle", fill: "#b0a48e", fontSize: 13, fontFamily: "'Playfair Display', serif", children: "\u0412\u0430\u0448\u0430\u0442\u0430 \u0441\u043D\u0438\u043C\u043A\u0430" })] })), wantPhoto && photo && (_jsx("g", { clipPath: "url(#holeClip)", children: _jsx("image", { href: photo, x: photoPos.x, y: photoPos.y, width: dw, height: dh }) })), _jsx("g", { mask: wantPhoto ? 'url(#labelMask)' : undefined, children: shape.renderBody(labelColor, true) }), wantPhoto && (_jsxs("g", { opacity: 0.5, children: [frameType === 'ellipse' && _jsx("ellipse", { cx: shape.hole.cx, cy: shape.hole.cy, rx: cfRX + 5, ry: cfRY + 5, fill: "none", stroke: ringColor, strokeWidth: 1.5 }), frameType === 'circle' && _jsx("circle", { cx: shape.hole.cx, cy: shape.hole.cy, r: cfRX + 5, fill: "none", stroke: ringColor, strokeWidth: 1.5 }), (frameType === 'square' || frameType === 'rect') && _jsx("rect", { x: shape.hole.cx - cfRX - 5, y: shape.hole.cy - cfRY - 5, width: (cfRX + 5) * 2, height: (cfRY + 5) * 2, rx: 6, fill: "none", stroke: ringColor, strokeWidth: 1.5 })] })), showLogo && (_jsx("image", { href: withVersion('/images/logo_resized.svg'), x: logoX - logoW / 2, y: logoY - logoH / 2, width: logoW, height: logoH, opacity: .85, filter: logoColor ? 'url(#logoColorFilter)' : undefined, style: { cursor: step === 4 ? 'grab' : 'default' }, onMouseDown: function (e) { if (step === 4) {
                                                e.stopPropagation();
                                                beginDrag(e, 'logo', logoX, logoY);
                                            } }, onTouchStart: function (e) { if (step === 4) {
                                                e.stopPropagation();
                                                beginDrag(e, 'logo', logoX, logoY);
                                            } } })), decos.map(function (d, i) {
                                            var sz = DECO_SIZE * d.scale;
                                            return _jsx("image", { href: d.src, x: d.x - sz / 2, y: d.y - sz / 2, width: sz, height: sz, preserveAspectRatio: "xMidYMid meet", className: activeDecoIdx === i && step === 5 ? 'lbl-deco-active' : '', style: { cursor: step === 5 ? 'grab' : 'default' }, onMouseDown: function (e) { if (step === 5) {
                                                    e.stopPropagation();
                                                    setActiveDecoIdx(i);
                                                    beginDrag(e, "deco-".concat(i), d.x, d.y);
                                                } }, onTouchStart: function (e) { if (step === 5) {
                                                    e.stopPropagation();
                                                    setActiveDecoIdx(i);
                                                    beginDrag(e, "deco-".concat(i), d.x, d.y);
                                                } } }, d.uid);
                                        }), texts.map(function (t, i) {
                                            var fontAttrs = {
                                                fontFamily: t.fontFamily, fontSize: t.fontSize, fill: t.color,
                                                fontWeight: t.bold ? 'bold' : 'normal',
                                                fontStyle: t.italic ? 'italic' : 'normal',
                                                style: { cursor: step === 6 ? 'grab' : 'default' },
                                                onMouseDown: function (e) { if (step === 6) {
                                                    e.stopPropagation();
                                                    setActiveTextIdx(i);
                                                    beginDrag(e, "text-".concat(i), t.x, t.y);
                                                } },
                                                onTouchStart: function (e) { if (step === 6) {
                                                    e.stopPropagation();
                                                    setActiveTextIdx(i);
                                                    beginDrag(e, "text-".concat(i), t.x, t.y);
                                                } },
                                            };
                                            if (t.arcEnabled) {
                                                return (_jsx("text", __assign({}, fontAttrs, { children: _jsx("textPath", { href: "#arc-path-".concat(t.uid), startOffset: "50%", textAnchor: "middle", children: _jsx("tspan", { dy: t.fontSize * 0.35, children: t.content }) }) }), t.uid));
                                            }
                                            return (_jsx("text", __assign({ x: t.x, y: t.y, textAnchor: "middle", dominantBaseline: "middle" }, fontAttrs, { children: t.content }), t.uid));
                                        })] }) }) }), _jsxs("div", { className: "lbl-controls", children: [_jsx("h2", { className: "lbl-ctrl-title", children: STEPS[step - 1].label }), step === 1 && (_jsxs("div", { className: "lbl-panel", children: [_jsx("p", { className: "lbl-panel-hint", children: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u0430 \u043D\u0430 \u0432\u0430\u0448\u0438\u044F \u0435\u0442\u0438\u043A\u0435\u0442" }), _jsx("div", { className: "lbl-shape-grid", children: BASE_SHAPES.map(function (s) { return (_jsxs("button", { className: "lbl-shape-card".concat(shapeId === s.id ? ' active' : ''), onClick: function () { return selectShape(s.id); }, children: [_jsx("svg", { viewBox: s.vb, className: "lbl-shape-thumb", children: s.renderBody(THUMB_COLOR) }), _jsx("span", { children: s.label })] }, s.id)); }) }), _jsxs("div", { className: "lbl-shape-dims", children: [_jsx("label", { className: "lbl-field-label", children: "\u0420\u0430\u0437\u043C\u0435\u0440\u0438" }), shapeId === 'oval' && (_jsxs(_Fragment, { children: [_jsxs("span", { className: "lbl-dim-label", children: ["\u0428\u0438\u0440\u0438\u043D\u0430: ", ovalW, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 200, max: 600, step: 10, value: ovalW, onChange: function (e) { return setOvalW(+e.target.value); } }), _jsxs("span", { className: "lbl-dim-label", children: ["\u0412\u0438\u0441\u043E\u0447\u0438\u043D\u0430: ", ovalH, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 300, max: 800, step: 10, value: ovalH, onChange: function (e) { return setOvalH(+e.target.value); } })] })), shapeId === 'medallion' && (_jsxs(_Fragment, { children: [_jsxs("span", { className: "lbl-dim-label", children: ["\u0414\u0438\u0430\u043C\u0435\u0442\u044A\u0440: ", medallionSize, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 200, max: 600, step: 10, value: medallionSize, onChange: function (e) { return setMedallionSize(+e.target.value); } })] })), shapeId === 'diamond' && (_jsxs(_Fragment, { children: [_jsxs("span", { className: "lbl-dim-label", children: ["\u0428\u0438\u0440\u0438\u043D\u0430: ", diamondW, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 200, max: 600, step: 10, value: diamondW, onChange: function (e) { return setDiamondW(+e.target.value); } }), _jsxs("span", { className: "lbl-dim-label", children: ["\u0412\u0438\u0441\u043E\u0447\u0438\u043D\u0430: ", diamondH, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 300, max: 700, step: 10, value: diamondH, onChange: function (e) { return setDiamondH(+e.target.value); } })] })), shapeId === 'rectangle' && (_jsxs(_Fragment, { children: [_jsxs("span", { className: "lbl-dim-label", children: ["\u0428\u0438\u0440\u0438\u043D\u0430: ", horizW, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 300, max: 700, step: 10, value: horizW, onChange: function (e) { return setHorizW(+e.target.value); } }), _jsxs("span", { className: "lbl-dim-label", children: ["\u0412\u0438\u0441\u043E\u0447\u0438\u043D\u0430: ", horizH, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 180, max: 500, step: 10, value: horizH, onChange: function (e) { return setHorizH(+e.target.value); } })] })), shapeId === 'square' && (_jsxs(_Fragment, { children: [_jsxs("span", { className: "lbl-dim-label", children: ["\u0420\u0430\u0437\u043C\u0435\u0440: ", squareSize, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 200, max: 600, step: 10, value: squareSize, onChange: function (e) { return setSquareSize(+e.target.value); } })] })), shapeId === 'portrait' && (_jsxs(_Fragment, { children: [_jsxs("span", { className: "lbl-dim-label", children: ["\u0428\u0438\u0440\u0438\u043D\u0430: ", vertW, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 180, max: 500, step: 10, value: vertW, onChange: function (e) { return setVertW(+e.target.value); } }), _jsxs("span", { className: "lbl-dim-label", children: ["\u0412\u0438\u0441\u043E\u0447\u0438\u043D\u0430: ", vertH, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 300, max: 700, step: 10, value: vertH, onChange: function (e) { return setVertH(+e.target.value); } })] }))] })] })), step === 2 && (_jsxs("div", { className: "lbl-panel", children: [_jsx("p", { className: "lbl-panel-hint", children: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0446\u0432\u044F\u0442 \u043E\u0442 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0442\u0435 \u0438\u043B\u0438 \u0432\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D." }), _jsx("label", { className: "lbl-field-label", children: "\u0413\u043E\u0442\u043E\u0432\u0438 \u0446\u0432\u0435\u0442\u043E\u0432\u0435" }), _jsx("div", { className: "lbl-swatches", children: COLOR_PRESETS.map(function (c) { return (_jsx("button", { className: "lbl-swatch".concat(labelColor === c ? ' active' : ''), style: { backgroundColor: c }, onClick: function () { return setLabelColor(c); } }, c)); }) }), _jsx("label", { className: "lbl-field-label", children: "\u0421\u0432\u043E\u0439 \u0446\u0432\u044F\u0442" }), _jsxs("div", { className: "lbl-color-custom-row", children: [_jsx("input", { type: "color", className: "lbl-color-native", value: /^#[0-9a-fA-F]{6}$/.test(colorInput) ? colorInput : labelColor, onChange: function (e) { setLabelColor(e.target.value); setColorInput(e.target.value.replace(/^#/, '')); } }), _jsxs("div", { className: "lbl-hex-wrap", children: [_jsx("span", { className: "lbl-color-hash", children: "#" }), _jsx("input", { type: "text", className: "lbl-hex-input", value: colorInput.replace(/^#/, ''), onChange: function (e) { return handleColorInput('#' + e.target.value.replace(/[^0-9a-fA-F]/g, '').slice(0, 6)); }, maxLength: 6, placeholder: "7B2323" })] })] })] })), step === 3 && (_jsxs("div", { className: "lbl-panel", children: [_jsxs("label", { className: "lbl-toggle-row lbl-photo-toggle", children: [_jsx("input", { type: "checkbox", checked: wantPhoto, onChange: function (e) { return setWantPhoto(e.target.checked); } }), _jsx("span", { children: "\u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0441\u043D\u0438\u043C\u043A\u0430 \u043A\u044A\u043C \u0435\u0442\u0438\u043A\u0435\u0442\u0430" })] }), _jsx("p", { className: "lbl-photo-privacy", children: "\uD83D\uDD12 \u0412\u0430\u0448\u0438\u0442\u0435 \u0441\u043D\u0438\u043C\u043A\u0438 \u043D\u0435 \u0441\u0435 \u043A\u0430\u0447\u0432\u0430\u0442 \u0438\u043B\u0438 \u0437\u0430\u043F\u0430\u0437\u0432\u0430\u0442 \u043D\u0430 \u043D\u0430\u0448\u0438\u0442\u0435 \u0441\u044A\u0440\u0432\u044A\u0440\u0438. \u0412\u0441\u0438\u0447\u043A\u043E \u0441\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0432\u0430 \u0434\u0438\u0440\u0435\u043A\u0442\u043D\u043E \u0432 \u0431\u0440\u0430\u0443\u0437\u044A\u0440\u0430 \u0432\u0438." }), wantPhoto && (_jsxs(_Fragment, { children: [_jsx("label", { className: "lbl-field-label", children: "\u0424\u043E\u0440\u043C\u0430 \u043D\u0430 \u0440\u0430\u043C\u043A\u0430\u0442\u0430" }), _jsx("div", { className: "lbl-frame-grid", children: FRAME_OPTIONS.map(function (f) { return (_jsx("button", { className: "lbl-frame-btn".concat(frameType === f.id ? ' active' : ''), onClick: function () { setFrameType(f.id); setFrameW(0); setFrameH(0); }, children: f.label }, f.id)); }) }), frameType === 'ellipse' && (_jsxs("div", { className: "lbl-frame-dims", children: [_jsxs("span", { className: "lbl-dim-label", children: ["\u0428\u0438\u0440\u0438\u043D\u0430: ", cfRX * 2, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 20, max: shape.hole.rx + 40, step: 2, value: cfRX, onChange: function (e) { return setFrameW(+e.target.value); } }), _jsxs("span", { className: "lbl-dim-label", children: ["\u0412\u0438\u0441\u043E\u0447\u0438\u043D\u0430: ", cfRY * 2, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 20, max: shape.hole.ry + 40, step: 2, value: cfRY, onChange: function (e) { return setFrameH(+e.target.value); } })] })), (frameType === 'circle' || frameType === 'square') && (_jsxs("div", { className: "lbl-frame-dims", children: [_jsxs("span", { className: "lbl-dim-label", children: ["\u0420\u0430\u0437\u043C\u0435\u0440: ", cfRX * 2, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 20, max: Math.min(shape.hole.rx, shape.hole.ry) + 30, step: 2, value: cfRX, onChange: function (e) { return setFrameW(+e.target.value); } })] })), frameType === 'rect' && (_jsxs("div", { className: "lbl-frame-dims", children: [_jsxs("span", { className: "lbl-dim-label", children: ["\u0428\u0438\u0440\u0438\u043D\u0430: ", cfRX * 2, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 20, max: shape.hole.rx + 40, step: 2, value: cfRX, onChange: function (e) { return setFrameW(+e.target.value); } }), _jsxs("span", { className: "lbl-dim-label", children: ["\u0412\u0438\u0441\u043E\u0447\u0438\u043D\u0430: ", cfRY * 2, "px"] }), _jsx("input", { type: "range", className: "lbl-range", min: 20, max: shape.hole.ry + 40, step: 2, value: cfRY, onChange: function (e) { return setFrameH(+e.target.value); } })] })), _jsx("label", { className: "lbl-field-label", children: "\u0421\u043D\u0438\u043C\u043A\u0430" }), _jsx("p", { className: "lbl-panel-hint", style: { marginBottom: 10 }, children: photo ? 'Плъзнете за позициониране, скролнете за мащабиране.' : 'Качете снимка, която да се появи в рамката.' }), _jsx("input", { ref: fileRef, type: "file", accept: "image/*", onChange: handleUpload, hidden: true }), _jsx("button", { className: "lbl-btn lbl-btn--primary", onClick: function () { var _a; return (_a = fileRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: photo ? 'Смени снимката' : 'Качи снимка' }), photo && (_jsxs(_Fragment, { children: [_jsx("label", { className: "lbl-field-label", children: "\u041C\u0430\u0449\u0430\u0431" }), _jsx("input", { type: "range", className: "lbl-range", min: photoBase * .15, max: photoBase * 5, step: photoBase * .01, value: photoScale, onChange: handleSlider }), _jsxs("details", { className: "lbl-cartoon-section", children: [_jsx("summary", { className: "lbl-cartoon-toggle", children: "\u0421\u0442\u0438\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0430\u0442\u0430" }), _jsx("div", { className: "lbl-cartoon-grid", children: CSTYLES.map(function (s) { return (_jsx("button", { className: "lbl-cartoon-btn".concat(cartoonId === s.id ? ' active' : ''), onClick: function () { return applyCartoon(s.id); }, disabled: processing, children: s.label }, s.id)); }) }), cartoonId && _jsx("button", { className: "lbl-btn lbl-btn--ghost", style: { marginTop: 8 }, onClick: resetCartoon, disabled: processing, children: "\u041E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u043D\u0430 \u0441\u043D\u0438\u043C\u043A\u0430" }), processing && _jsxs("div", { className: "lbl-processing", children: [_jsx("span", { className: "lbl-spinner" }), " \u041E\u0431\u0440\u0430\u0431\u043E\u0442\u0432\u0430\u043D\u0435\u2026"] })] })] }))] }))] })), step === 4 && (_jsxs("div", { className: "lbl-panel", children: [_jsx("p", { className: "lbl-panel-hint", children: "\u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u043B\u043E\u0433\u043E\u0442\u043E \u043D\u0430 \u041A\u0430\u043C\u0435\u044F. \u041F\u043B\u044A\u0437\u043D\u0435\u0442\u0435 \u0432 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430 \u0437\u0430 \u043F\u043E\u0437\u0438\u0446\u0438\u043E\u043D\u0438\u0440\u0430\u043D\u0435, \u0441\u043A\u0440\u043E\u043B\u043D\u0435\u0442\u0435 \u0437\u0430 \u043C\u0430\u0449\u0430\u0431\u0438\u0440\u0430\u043D\u0435." }), _jsxs("label", { className: "lbl-toggle-row", children: [_jsx("input", { type: "checkbox", checked: showLogo, onChange: function (e) { return setShowLogo(e.target.checked); } }), _jsx("span", { children: "\u041F\u043E\u043A\u0430\u0436\u0438 \u043B\u043E\u0433\u043E" })] }), showLogo && (_jsxs(_Fragment, { children: [_jsx("label", { className: "lbl-field-label", children: "\u0420\u0430\u0437\u043C\u0435\u0440" }), _jsx("input", { type: "range", className: "lbl-range", min: .3, max: 3, step: .05, value: logoScale, onChange: function (e) { return setLogoScale(parseFloat(e.target.value)); } }), _jsx("label", { className: "lbl-field-label", children: "\u0426\u0432\u044F\u0442 \u043D\u0430 \u043B\u043E\u0433\u043E\u0442\u043E" }), _jsxs("div", { className: "lbl-swatches", style: { marginBottom: 8 }, children: [_jsx("button", { className: "lbl-swatch lbl-swatch--checker".concat(logoColor === '' ? ' active' : ''), onClick: function () { setLogoColor(''); setLogoColorInput(''); }, title: "\u041E\u0440\u0438\u0433\u0438\u043D\u0430\u043B\u0435\u043D \u0446\u0432\u044F\u0442" }), LOGO_COLOR_PRESETS.map(function (c) { return (_jsx("button", { className: "lbl-swatch".concat(logoColor === c ? ' active' : ''), style: { backgroundColor: c }, onClick: function () { setLogoColor(c); setLogoColorInput(c); } }, c)); })] }), _jsxs("div", { className: "lbl-color-custom-row", children: [_jsx("div", { className: "lbl-color-preview-box lbl-color-preview-sm", style: { backgroundColor: logoColor || 'transparent', border: !logoColor ? '2px dashed #d5c9ba' : undefined } }), _jsxs("div", { className: "lbl-hex-wrap", children: [_jsx("span", { className: "lbl-color-hash", children: "#" }), _jsx("input", { type: "text", className: "lbl-hex-input", value: logoColorInput.replace(/^#/, ''), onChange: function (e) { return handleLogoColorInput('#' + e.target.value.replace(/[^0-9a-fA-F]/g, '').slice(0, 6)); }, maxLength: 6, placeholder: "\u0431\u0435\u0437 \u0446\u0432\u044F\u0442" })] }), logoColor && _jsx("button", { className: "lbl-btn lbl-btn--ghost lbl-btn--sm", onClick: function () { setLogoColor(''); setLogoColorInput(''); }, children: "\u2715" })] })] }))] })), step === 5 && (_jsxs("div", { className: "lbl-panel", children: [_jsx("p", { className: "lbl-panel-hint", children: "\u041F\u043B\u044A\u0437\u043D\u0435\u0442\u0435 \u0434\u0435\u043A\u043E\u0440\u0430\u0446\u0438\u0438 \u0432 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430 \u0437\u0430 \u043F\u043E\u0437\u0438\u0446\u0438\u043E\u043D\u0438\u0440\u0430\u043D\u0435, \u0441\u043A\u0440\u043E\u043B\u043D\u0435\u0442\u0435 \u0437\u0430 \u043C\u0430\u0449\u0430\u0431\u0438\u0440\u0430\u043D\u0435." }), _jsx("div", { className: "lbl-deco-cats", children: DECO_CATEGORIES.map(function (cat) { return (_jsx("button", { className: "lbl-deco-cat-tab".concat(activeDecoCategory === cat.id ? ' active' : ''), onClick: function () { return setActiveDecoCategory(cat.id); }, children: cat.label }, cat.id)); }) }), _jsxs("div", { className: "lbl-deco-catalog", children: [((_b = (_a = DECO_CATEGORIES.find(function (c) { return c.id === activeDecoCategory; })) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []).map(function (item) { return (_jsxs("button", { className: "lbl-deco-cat-btn", onClick: function () { return addDeco(item); }, title: item.label, children: [_jsx("img", { src: item.src, alt: item.label, className: "lbl-deco-cat-img" }), _jsx("span", { children: item.label })] }, item.id)); }), ((_d = (_c = DECO_CATEGORIES.find(function (c) { return c.id === activeDecoCategory; })) === null || _c === void 0 ? void 0 : _c.items) !== null && _d !== void 0 ? _d : []).length === 0 && (_jsx("p", { className: "lbl-panel-hint", style: { gridColumn: '1/-1', fontSize: '.78rem' }, children: "\u0421\u043A\u043E\u0440\u043E \u0449\u0435 \u0431\u044A\u0434\u0430\u0442 \u0434\u043E\u0431\u0430\u0432\u0435\u043D\u0438." }))] }), _jsxs("div", { className: "lbl-deco-upload", children: [_jsx("input", { ref: decoFileRef, type: "file", accept: ".svg,.png,image/svg+xml,image/png", onChange: handleDecoUpload, hidden: true }), _jsx("button", { className: "lbl-btn lbl-btn--ghost lbl-btn--sm", onClick: function () { var _a; return (_a = decoFileRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: "+ \u041A\u0430\u0447\u0438 \u0441\u0432\u043E\u044F (.svg/.png)" })] }), decos.length > 0 && (_jsxs(_Fragment, { children: [_jsx("label", { className: "lbl-field-label", children: "\u041F\u043E\u0441\u0442\u0430\u0432\u0435\u043D\u0438" }), decos.map(function (d, i) { return (_jsxs("div", { className: "lbl-deco-item".concat(activeDecoIdx === i ? ' active' : ''), onClick: function () { return setActiveDecoIdx(i); }, children: [_jsx("span", { className: "lbl-deco-item-name", children: d.label }), _jsx("button", { className: "lbl-deco-remove", onClick: function (e) { e.stopPropagation(); removeDeco(i); }, children: "\u00D7" })] }, d.uid)); })] })), activeDecoIdx >= 0 && activeDecoIdx < decos.length && (_jsxs("div", { className: "lbl-deco-props", children: [_jsx("label", { className: "lbl-field-label", children: "\u0420\u0430\u0437\u043C\u0435\u0440" }), _jsx("input", { type: "range", className: "lbl-range", min: .1, max: 10, step: .05, value: decos[activeDecoIdx].scale, onChange: function (e) { return updateDeco(activeDecoIdx, { scale: parseFloat(e.target.value) }); } }), _jsx("label", { className: "lbl-field-label", children: "\u0425\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u043D\u043E" }), _jsx("input", { type: "range", className: "lbl-range", min: 0, max: shape.w, step: 1, value: decos[activeDecoIdx].x, onChange: function (e) { return updateDeco(activeDecoIdx, { x: +e.target.value }); } }), _jsx("label", { className: "lbl-field-label", children: "\u0412\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u043D\u043E" }), _jsx("input", { type: "range", className: "lbl-range", min: 0, max: shape.h, step: 1, value: decos[activeDecoIdx].y, onChange: function (e) { return updateDeco(activeDecoIdx, { y: +e.target.value }); } })] }))] })), step === 6 && (_jsxs("div", { className: "lbl-panel", children: [_jsx("p", { className: "lbl-panel-hint", children: "\u0414\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0442\u0435\u043A\u0441\u0442. \u041F\u043B\u044A\u0437\u043D\u0435\u0442\u0435 \u0432 \u043F\u0440\u0435\u0433\u043B\u0435\u0434\u0430 \u0437\u0430 \u043F\u043E\u0437\u0438\u0446\u0438\u043E\u043D\u0438\u0440\u0430\u043D\u0435, \u0441\u043A\u0440\u043E\u043B\u043D\u0435\u0442\u0435 \u0437\u0430 \u0440\u0430\u0437\u043C\u0435\u0440." }), _jsx("button", { className: "lbl-btn lbl-btn--primary", onClick: addText, children: "+ \u0414\u043E\u0431\u0430\u0432\u0438 \u0442\u0435\u043A\u0441\u0442" }), texts.map(function (t, i) { return (_jsxs("div", { className: "lbl-text-item".concat(activeTextIdx === i ? ' active' : ''), onClick: function () { return setActiveTextIdx(i); }, children: [_jsxs("div", { className: "lbl-text-item-head", children: [_jsx("input", { className: "lbl-text-input", value: t.content, onChange: function (e) { return updateText(i, { content: e.target.value }); }, onClick: function (e) { return e.stopPropagation(); }, placeholder: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0442\u0435\u043A\u0441\u0442\u2026" }), _jsx("button", { className: "lbl-deco-remove", onClick: function (e) { e.stopPropagation(); removeText(i); }, children: "\u00D7" })] }), activeTextIdx === i && (_jsxs("div", { className: "lbl-text-props", children: [_jsx("label", { className: "lbl-field-label", children: "\u0428\u0440\u0438\u0444\u0442" }), _jsx("select", { className: "lbl-select", value: t.fontFamily, onChange: function (e) { return updateText(i, { fontFamily: e.target.value }); }, children: FONT_OPTIONS.map(function (f) { return _jsx("option", { value: f.value, children: f.label }, f.value); }) }), _jsx("label", { className: "lbl-field-label", children: "\u0420\u0430\u0437\u043C\u0435\u0440" }), _jsx("input", { type: "range", className: "lbl-range", min: 8, max: 56, step: 1, value: t.fontSize, onChange: function (e) { return updateText(i, { fontSize: parseInt(e.target.value) }); } }), _jsx("label", { className: "lbl-field-label", children: "\u0426\u0432\u044F\u0442" }), _jsxs("div", { className: "lbl-color-custom-row", children: [_jsx("input", { type: "color", className: "lbl-color-native", value: t.color, onChange: function (e) { return updateText(i, { color: e.target.value }); } }), _jsxs("div", { className: "lbl-hex-wrap", children: [_jsx("span", { className: "lbl-color-hash", children: "#" }), _jsx("input", { type: "text", className: "lbl-hex-input", value: t.color.replace(/^#/, ''), onChange: function (e) { var v = '#' + e.target.value.replace(/[^0-9a-fA-F]/g, '').slice(0, 6); if (/^#[0-9a-fA-F]{6}$/.test(v))
                                                                                updateText(i, { color: v }); }, maxLength: 6 })] })] }), _jsxs("div", { className: "lbl-text-toggles", children: [_jsx("button", { className: "lbl-toggle-btn".concat(t.bold ? ' on' : ''), onClick: function () { return updateText(i, { bold: !t.bold }); }, children: "B" }), _jsx("button", { className: "lbl-toggle-btn".concat(t.italic ? ' on' : ''), style: { fontStyle: 'italic' }, onClick: function () { return updateText(i, { italic: !t.italic }); }, children: "I" })] }), _jsxs("label", { className: "lbl-toggle-row", style: { marginTop: 12 }, children: [_jsx("input", { type: "checkbox", checked: t.arcEnabled, onChange: function (e) { return updateText(i, { arcEnabled: e.target.checked }); } }), _jsx("span", { children: "\u0422\u0435\u043A\u0441\u0442 \u043F\u043E \u0434\u044A\u0433\u0430" })] }), t.arcEnabled && (_jsxs(_Fragment, { children: [_jsx("label", { className: "lbl-field-label", children: "\u0420\u0430\u0434\u0438\u0443\u0441 \u043D\u0430 \u0434\u044A\u0433\u0430\u0442\u0430" }), _jsx("input", { type: "range", className: "lbl-range", min: 1, max: 100, step: 1, value: Math.round(1 + 99 * Math.log(t.arcRadius / 30) / Math.log(600 / 30)), onChange: function (e) { return updateText(i, { arcRadius: Math.round(30 * Math.pow(600 / 30, (+e.target.value - 1) / 99)) }); } }), _jsx("label", { className: "lbl-field-label", children: "\u041F\u043E\u0441\u043E\u043A\u0430" }), _jsxs("div", { className: "lbl-frame-grid", style: { gridTemplateColumns: '1fr 1fr' }, children: [_jsx("button", { className: "lbl-frame-btn".concat(t.arcDirection === 'top' ? ' active' : ''), onClick: function () { return updateText(i, { arcDirection: 'top' }); }, children: "\u2322 \u041D\u0430\u0433\u043E\u0440\u0435" }), _jsx("button", { className: "lbl-frame-btn".concat(t.arcDirection === 'bottom' ? ' active' : ''), onClick: function () { return updateText(i, { arcDirection: 'bottom' }); }, children: "\u2323 \u041D\u0430\u0434\u043E\u043B\u0443" })] })] }))] }))] }, t.uid)); })] })), _jsxs("div", { className: "lbl-nav", children: [step > 1 && _jsx("button", { className: "lbl-btn lbl-btn--ghost", onClick: function () { return setStep(function (s) { return s - 1; }); }, children: "\u2190 \u041D\u0430\u0437\u0430\u0434" }), _jsx("div", { className: "lbl-nav-spacer" }), step < 6 && _jsx("button", { className: "lbl-btn lbl-btn--primary", onClick: function () { return setStep(function (s) { return s + 1; }); }, children: "\u041D\u0430\u043F\u0440\u0435\u0434 \u2192" }), step === 6 && _jsx("button", { className: "lbl-btn lbl-btn--accent", onClick: handleDownload, children: "\u0418\u0437\u0442\u0435\u0433\u043B\u0438 \u0435\u0442\u0438\u043A\u0435\u0442\u0430" })] })] })] })] }) }));
};
export default LabelsPage;
